// OTP API endpoints
export const sendOTPUrl = () => `/customers/generate-otp-system`;

export const verifyOTPUrl = () => `/customers/verify-otp`;
